import UNI_QUANT_EXT_1 from "./UNI_QUANT_EXT_1";
export default {
  UNI_QUANT_EXT_1,
};
